import styled from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {View} from '../../../../uikit/View';
import {MODAL_CLASS_NAMES} from '../../constants';

export const Container = styled(View).attrs({
  className: MODAL_CLASS_NAMES.footerContainer,
})<{modalPadding: number}>`
  background-color: ${getColor('background.white')};
  padding-block-end: ${p => ms(p.modalPadding)};
  padding-inline: ${p => ms(p.modalPadding)};
  width: 100%;
`;
